module.exports = __webpack_public_path__ + "img/magnifier.d444ca5.svg";